document.addEventListener('DOMContentLoaded', () => {
  const btnsEdit = document.querySelectorAll('.btn-edit-kategori');
  const modal = document.getElementById('modalKategoriUnit');
  const inputId = document.getElementById('typeKategoriUnitId');
  const inputName = document.getElementById('kategoriUnitName');
  const inputDescription = document.getElementById('kategoriUnitDescription');
  const imgPreview = document.getElementById('kategoriUnitImagePreview');

  btnsEdit.forEach(button => {
    button.addEventListener('click', () => {
      const id = button.dataset.id || '';
      const name = button.dataset.name || '';
      const description = button.dataset.description || '';
      const imagePath = button.dataset.imagePath || '';

      inputId.value = id;
      inputName.value = name;
      inputDescription.value = description;

      if (imgPreview) {
        if (imagePath) {
          imgPreview.src = `/images/${imagePath}`;
          imgPreview.style.display = 'block';
        } else {
          imgPreview.src = '';
          imgPreview.style.display = 'none';
        }
      }

      modal.classList.remove('hidden');
    });
  });
});

export function openModalKategoriUnit(data = null) {
    const modal = document.getElementById('modalKategoriUnit');
    const form = document.getElementById('formKategoriUnit');
    const idInput = document.getElementById('typeKategoriUnitId');
    const nameInput = document.getElementById('KategoriUnitName');
    const imageInput = document.getElementById('KategoriUnitImage');

    if (data) {
        idInput.value = data.id ?? '';
        nameInput.value = data.name ?? '';
        imageInput.value = '';
    } else {
        form.reset();
        idInput.value = '';
    }

    modal.classList.remove('hidden');
}

export function closeModalKategoriUnit() {
    const modal = document.getElementById('modalKategoriUnit');
    const form = document.getElementById('formKategoriUnit');
    form.reset();
    modal.classList.add('hidden');
}

// Optional: close modal on clicking outside modal content
window.addEventListener('click', (e) => {
    const modal = document.getElementById('modalKategoriUnit');
    if (!modal) return;
    if (!modal.classList.contains('hidden') && e.target === modal) {
        closeModalKategoriUnit();
    }
});
